import { BRAZILIAN_STATES } from '../states';
import { validations } from './validations';

/**
 * Demographic questions: state, age, income, education, race, gender, orientation
 */
export const demographicsQuestions = [
  {
    id: 'state',
    question: 'Em qual estado você mora?',
    type: 'select',
    options: BRAZILIAN_STATES,
    validation: validations.required
  },
  {
    id: 'age',
    question: 'Quantos anos você tem?',
    type: 'number',
    min: 18,
    max: 100,
    validation: validations.age
  },
  {
    id: 'income-source',
    question: 'Qual é a sua fonte de renda?',
    type: 'radio',
    options: [
      { value: 'autônomo ou autônoma/freelancer', label: 'Autônomo ou autônoma/freelancer'},
      { value: 'aposentado ou aposentada / pensionista', label: 'Aposentado ou aposentada/pensionista'},
      { value: 'contratado ou contratada CLT', label: 'Contratado ou contratada CLT'},
      { value: 'contratado ou contratada como pessoa jurídica', label: 'Contratado ou contratada como pessoa jurídica'},
      { value: 'empresário ou empresária', label: 'Empresário ou empresária'},
      { value: 'funcionário ou funcionária pública', label: 'Funcionário ou funcionária pública'},
      { value: 'sem renda', label: 'Sem renda'},
      { value: 'prefiro não dizer', label: 'Prefiro não dizer'},
    ],
    validation: validations.required
  },
  {
    id: 'scholarity',
    question: 'Qual é a sua escolaridade?',
    type: 'radio',
    options: [
      { value:'fundamental', label: 'Fundamental'},
      { value:'médio (segundo grau)', label: 'Médio (segundo grau)'},
      { value:'superior completo', label: 'Superior completo'},
      { value:'superior incompleto', label: 'Superior incompleto'},
      { value:'mBA/Pós-graduação', label: 'MBA/Pós-graduação'},
      { value:'mestrado', label: 'Mestrado'},
      { value:'doutorado', label: 'Doutorado'},
      { value:'prefiro não dizer', label: 'Prefiro não dizer'},
    ],
    validation: validations.required
  },
  {
    id: 'family-income',
    question: 'Qual sua renda familiar (em reais)?',
    type: 'radio',
    options: [
      { value: 'até 2.424,00', label: 'Até 2.424,00' },
      { value: '2.424,01 a 3.636,00', label: '2.424,01 a 3.636,00' },
      { value: '3.636,01 a 7.272,00', label: '3.636,01 a 7.272,00' },
      { value: '7.272,01 a 12.120,00', label: '7.272,01 a 12.120,00' },
      { value: '12.120,01 a 18.180,00', label: '12.120,01 a 18.180,00' },
      { value: '18.180,01 a 30.300,00', label: '18.180,01 a 30.300,00' },
      { value: '30.300,01 ou mais', label: '30.300,01 ou mais' },
      { value: 'prefiro não responder', label: 'Prefiro não responder' },
    ],
    validation: validations.required
  },
  {
    id: 'race',
    question: 'Qual a sua raça/cor?',
    subtitle: '(Conforme classificação do IBGE)',
    type: 'radio',
    options: [
      { value: 'amarela', label: 'Amarela' },
      { value: 'indigena', label: 'Indígena' },
      { value: 'branca', label: 'Branca' },
      { value: 'parda', label: 'Parda' },
      { value: 'preta', label: 'Preta' }
    ],
    validation: validations.required
  },
  {
    id: 'gender',
    question: 'Como você identifica o seu gênero?',
    type: 'radio',
    options: [
      { value: 'homem', label: 'Homem' },
      { value: 'mulher', label: 'Mulher' },
      { value: 'não binario', label: 'Não binário' },
      { value: 'prefiro não dizer', label: 'Prefiro não dizer' }
    ],
    validation: validations.required
  },
  {
    id: 'sexual-orientation',
    question: 'Qual sua orientação sexual?',
    type: 'radio',
    options: [
      { value: 'assexual', label: 'Assexual' },
      { value: 'bissexual', label: 'Bissexual' },
      { value: 'heterossexual', label: 'Heterossexual' },
      { value: 'homossexual', label: 'Homossexual' },
      { value: 'pansexual', label: 'Pansexual' },
      { value: 'prefiro não dizer', label: 'Prefiro não dizer' }
    ],
    validation: validations.required
  },
];
